export default (theme) => ({
  root: {
    fontSize: theme.typography.pxToRem(17),
    fontWeight: theme.typography.fontWeightBold,
    margin: theme.spacing(1),
    textAlign: 'center',
  },
});
